import request from '@/router/axios'
import env from '@/config/env'
// 退款原因分页列表
export const queryList = (data) => {
  return request({
    url: env.ferryUrl + '/refundReason/record',
    method: 'POST',
    data
  })
}

// 退款原因配置列表
export const configList = (params) => {
  return request({
    url: env.ferryUrl + '/refundReason/con/listAll',
    method: 'GET',
    params
  })
}

// 退款原因配置保存或更新
export const saveOrUpdate = (data) => {
  return request({
    url: env.ferryUrl + '/refundReason/con/saveOrUpdate',
    method: 'POST',
    data
  })
}

// 删除配置选项
export const refundDel = (id) => {
  return request({
    url: env.ferryUrl + `/refundReason/con/del/${id}`,
    method: 'DELETE'
  })
}
